// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const offcerApi = baseApi.injectEndpoints({
  reducerPath: "userApi",
  endpoints: (builder) => ({
    getAllOfficers: builder.query({
      query: ({ search = '', limit, page }) => {
        return {
          url: `officer-list?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      refetchOnInterval: 1000, 
      refetchOnFocus: true,
      keepUnusedDataFor: 0,
    }),
    getOfficerLogs: builder.query({
      query: ({ id = '', start_datetime, end_datetime }) => {
        return {
          url: `officer-logs?officer_id=${id}&start_datetime=${start_datetime}&end_datetime=${end_datetime}&is_paginate=false`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      refetchOnFocus: true,
      keepUnusedDataFor: 0
    }),
    markOfficer: builder.mutation({
      query: (id) => {
        return {
          url:  `/mark-officer-fine/${id}`,
          method: "POST",
      };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllOfficersQuery,
  useGetOfficerLogsQuery,
  useMarkOfficerMutation
} = offcerApi;
